import {connect} from 'react-redux';

import {changeImage} from 'topmeteo/base-image/actionCreators';
import {mapStateToProps} from 'topmeteo/base-image/components/ChangeImageButton';

import BaseArrow from './BaseArrow';

const BaseArrowWrapper = ({disabled, ...props}) => disabled || <BaseArrow {...props} />;

BaseArrowWrapper.defaultProps = {
    change: changeImage,
};

export default connect(mapStateToProps)(BaseArrowWrapper);
